import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';

@Component({
	selector: 'select-existing-shootproof-gallery-modal',
	template: require('./select-existing-shootProof-gallery.modal.html'),
	styles: [require('./select-existing-shootProof-gallery.modal.scss')]
})
export class SelectExistingShootProofGalleryModal {
	@Input('jobId') jobId: number;
	@Input('brandsGalleries') brandsGalleries: Array<any>;
	@Output('updateGalleries')
	updateGalleries: EventEmitter<any> = new EventEmitter<any>();

	galleriesListDisable = true;
	onSubmitSpinner = false;

	readonly DEFAULT_GALLERY_PRESET = [
		{ spGalleryId: -1, name: 'Choose Gallery' }
	];
	readonly LOADING_GALLERY_PRESET = [{ spGalleryId: -1, name: 'Loading...' }];

	selectedShootProofBrandId = -1;
	selectedGalleryId = -1;

	galleriesList = this.DEFAULT_GALLERY_PRESET;

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService,
		private invoiceDataService: InvoicesDataProvider
	) {}

	selectBrand(shootProofBrandId) {
		if (shootProofBrandId != -1) {
			this.selectedShootProofBrandId = shootProofBrandId;
			this.galleriesListDisable = true;
			this.galleriesList = this.LOADING_GALLERY_PRESET;

			this.shootProofDataService
				.getGalleriesToImportV1(shootProofBrandId)
				.subscribe(
					data => {
						this.galleriesListDisable = false;
						this.galleriesList = this.DEFAULT_GALLERY_PRESET.concat(data.data);
					},
					error => {
						this.galleriesList = this.DEFAULT_GALLERY_PRESET;
						this.checkIfShootProofError(error);
					}
				);
		} else {
			this.selectedShootProofBrandId = -1;
			this.selectedGalleryId = -1;
			this.galleriesList = this.DEFAULT_GALLERY_PRESET;
			this.galleriesListDisable = true;
		}
	}

	selectGallery(galleryId) {
		if (galleryId !== -1) {
			this.selectedGalleryId = galleryId;
		}
	}

	dismiss(): void {
		this.selectedGalleryId = -1;
		this.selectedShootProofBrandId = -1;
		this.galleriesList = this.DEFAULT_GALLERY_PRESET;
		this.brandsGalleries = [];
		this.galleriesListDisable = true;
		this.onSubmitSpinner = false;
	}

	onSubmit(): void {
		this.onSubmitSpinner = true;

		const galleryParamsToSend = {
			jobId: this.jobId,
			spGalleryId: +this.selectedGalleryId,
			spBrandId: +this.selectedShootProofBrandId,
			importOrders: false
		};

		this.shootProofDataService
			.selectExistingGaleryV1(galleryParamsToSend)
			.finally(() => (this.onSubmitSpinner = false))
			.subscribe(
				() => this.successSelectExistingGallery(),
				error => this.checkIfShootProofError(error)
			);
	}

	private successSelectExistingGallery() {
		this.updateGalleries.emit();
		this.invoiceDataService.emitInvoiceUpdateEvent('UPDATE_SP_INVOICES');
		this.dismiss();
		this.messageService.showToaster('s_3', 'shootProof');
		$('#selectExistingShoopProofGalleryModal').modal('hide');
	}

	private checkIfShootProofError(error): void {
		if (error.status === 500) {
			this.messageService.showToaster('e_1', 'shootProof');
		} else {
			this.messageService.showDefaultErrorMessage(error);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/integrations/shootProof/modals/select-existing-shootProof-gallery-modal/select-existing-shootProof-gallery.modal.ts